import type { SportContext } from './sportContext';
import { getActiveSchool } from '../utils/activeSchool';

export interface OnboardingTourContext extends SportContext {
  /** Ребёнок привязан к школе (Parent) или ученик в школе (Member). */
  hasLinkedSchool: boolean;
}

export function buildOnboardingTourContext(sportCtx: SportContext): OnboardingTourContext {
  const active = getActiveSchool();
  const role = typeof window !== 'undefined'
    ? (localStorage.getItem('role') || localStorage.getItem('accountRole') || '')
    : '';
  let hasLinkedSchool = Boolean(
    active?.schoolId
    && (active.accessRole === 'member' || active.studentId != null)
  );
  if (role === 'Parent') {
    hasLinkedSchool = Boolean(active?.schoolId);
  }
  return { ...sportCtx, hasLinkedSchool };
}
